import { createSlice } from '@reduxjs/toolkit';

interface RoleState {
    role: any | null;
}

const roleSlice = createSlice({
    name: 'role',
    initialState: { role: null } as RoleState,
    reducers: {
        setRole: (state: any, action: any) => {
            state.role = action.payload;
        },
        clearRole: (state: any) => {
            state.role = null;
        },
    },
});

export const { setRole, clearRole } = roleSlice.actions;
export default roleSlice.reducer;
